import * as React from 'react';
import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Logo from 'components/Logo';
import { env } from 'constants';
import { LayoutContext } from 'constants/contexts';
import SearchOverlay from './SearchOverlay';
import AddressButton from './AddressButton';
import ProfileButton from './ProfileButton';
import CartButton from '../../CartButton';
import { HeaderElements } from './constants';
import Title from './Title';

function HeaderDesktop({ visibleElements, title }) {
  const { headerHeight } = React.useContext(LayoutContext);
  function renderIfIsVisible(name, element) {
    if (visibleElements?.includes(name)) {
      return element;
    }
    return null;
  }

  return (
    <Grid container width="100%" height={headerHeight} alignItems="center" mt={2} spacing={1} justifyContent="space-between">
      <Grid size={(!env.IS_MARKETPLACE && !env.IS_CATERING) ? 4 : 8} height="100%" sx={visibleElements === 'logo' && { width: '100%' }}>
        <Stack direction="row" alignItems="center" spacing={4} sx={{ height: '100%', p: 1 }}>
          {renderIfIsVisible(HeaderElements.LOGO, <Logo />)}
          {title &&
          renderIfIsVisible(HeaderElements.TITLE, typeof title === 'string' ? <Title title={title} /> : title)}
          {!env.IS_CATERING && renderIfIsVisible(HeaderElements.ADDRESS_BUTTON, <AddressButton />)}
        </Stack>
      </Grid>
      {!env.IS_MARKETPLACE && !env.IS_CATERING && (
        <Grid size={4}>
          {renderIfIsVisible(HeaderElements.SEARCH, <SearchOverlay backdrop />)}
        </Grid>
      )}

      <Grid size={4}>
        <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center" width="100%">
          {env.IS_CATERING && renderIfIsVisible(HeaderElements.ADDRESS_BUTTON, <AddressButton />)}
          {renderIfIsVisible(HeaderElements.USER_BUTTON, <ProfileButton />)}
          {!env.IS_CATERING && renderIfIsVisible(HeaderElements.CART_BUTTON, <CartButton />)}
        </Stack>
      </Grid>
    </Grid>
  );
}

export default HeaderDesktop;
